import { Tooltip } from '@mui/material';

import InfoIcon from '@mui/icons-material/Info';

export const amenitiesColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  {
    Header: 'Amenity Image',
    accessor: 'image',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  { Header: 'Amenity Name', accessor: 'name', align: 'left' },
  {
    Header: 'Actions',
    accessor: 'actions',
    align: 'center',
    disableFilters: true,
    disableSortBy: true,
    // cellClass: 'text-muted w-20',
  },
];

export const faqsColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  {
    Header: 'Questions',
    accessor: 'question',
    align: 'left',
  },
  {
    Header: 'Priority',
    accessor: 'priorityIndex',
    align: 'left',
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    align: 'center',
    disableFilters: true,
    disableSortBy: true,
  },
];

export const legalColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  {
    Header: 'Legal',
    accessor: 'title',
    align: 'left',
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    align: 'center',
    disableFilters: true,
    disableSortBy: true,
    // cellClass: 'text-muted w-20',
  },
];

// User Email columns

export const emailColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  {
    Header: 'Subject',
    accessor: 'subject',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Date',
    accessor: 'date',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    align: 'center',
    disableFilters: true,
    disableSortBy: true,
    // cellClass: 'text-muted w-20',
  },
];

// User Sms columns

export const smsColumns = [
  {
    Header: 'Body',
    accessor: 'body',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Date',
    accessor: 'date',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  }
]

export const propertyTypesColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  {
    Header: 'Property Type Image',
    accessor: 'image',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  { Header: 'Property Type', accessor: 'name', align: 'left' },
  {
    Header: 'Property Count',
    accessor: 'propertyCount',
    align: 'center',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    align: 'center',
    disableFilters: true,
    disableSortBy: true,
    // cellClass: 'text-muted w-20',
  },
];

// User Management Columns for userlist 
export const usUsersColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  {
    Header: 'Legal Name',
    accessor: 'firstName',
    align: 'left',
  },
  { Header: 'Email', accessor: 'email', align: 'left' },
  {
    Header: 'State',
    accessor: 'state',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'City',
    accessor: 'city',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'KYC Approved',
    accessor: 'accountStatus',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Admin Approved',
    accessor: 'isAdminApproved',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Investment Status',
    accessor: 'investmentStatus',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Regulation D Status',
    accessor: 'regulationDStatus',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Properties Invested',
    accessor: 'propertiesInvested',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Total Value',
    accessor: 'propertyValue',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'SSN',
    accessor: 'encodedSSN',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  { Header: 'Phone Number', accessor: 'phoneNumber', align: 'right' },
  {
    Header: 'Referral Code',
    accessor: 'referredBy',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Referred By User',
    accessor: 'referredByUser',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Subscribe For SMS',
    accessor: 'subscribeForSMS',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'OnBoarding Stage',
    accessor: 'onboardingStage',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Registered On',
    accessor: 'registeredOn',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: (
      <>
        Action
        <Tooltip title="Freeze means the user will be block for investing further and for doing any transactions">
          <InfoIcon sx={{ marginLeft: '4px' }} />
        </Tooltip>
      </>
    ),
    accessor: 'isFreeze',
    align: 'center',
    disableFilters: true,
    disableSortBy: true,
  },
];

// User management export list columns

export const usUsersExportColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  {
    Header: 'Legal Name',
    accessor: 'firstName',
    align: 'left',
  },
  { Header: 'Email', accessor: 'email', align: 'left' },
  {
    Header: 'State',
    accessor: 'state',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'City',
    accessor: 'city',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'KYC Approved',
    accessor: 'accountStatus',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Admin Approved',
    accessor: 'isAdminApproved',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Investment Status',
    accessor: 'investmentStatus',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Regulation D Status',
    accessor: 'regulationDStatus',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Properties Invested',
    accessor: 'propertiesInvested',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Total Value',
    accessor: 'propertyValue',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'SSN',
    accessor: 'encodedSSN',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  { Header: 'Phone Number', accessor: 'phoneNumber', align: 'right' },
  {
    Header: 'Referral Code',
    accessor: 'referredBy',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Referred By User',
    accessor: 'referredByUser',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Subscribe For SMS',
    accessor: 'subscribeForSMS',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'OnBoarding Stage',
    accessor: 'onboardingStage',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Registered On',
    accessor: 'registeredOn',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Last Login',
    accessor: 'lastSession',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'IP Address',
    accessor: 'ipAddress',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'IP City',
    accessor: 'ipCity',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'IP State',
    accessor: 'ipState',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'IP Country',
    accessor: 'ipCountry',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'IP Latitude',
    accessor: 'ipLatitude',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'IP Longitude',
    accessor: 'ipLongitude',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'isFreezed',
    accessor: 'isFreeze',
    align: 'center',
    disableFilters: true,
    disableSortBy: true,
  },
];

export const nonUsUsersColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  {
    Header: 'Legal Name',
    accessor: 'name',
    align: 'left',
  },
  { Header: 'Email', accessor: 'email', align: 'left' },
  {
    Header: 'Country',
    accessor: 'countryName',
    align: 'left',
    // disableFilters: true,
    // disableSortBy: true,
  },
  {
    Header: 'Phone Number',
    accessor: 'phoneNumber',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Referral Code',
    accessor: 'referredBy',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Subscribe For SMS',
    accessor: 'subscribeForSMS',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  }
];

export const duplicateUsersColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  {
    Header: 'Legal Name',
    accessor: 'firstName',
    align: 'left',
  },
  { Header: 'Email', accessor: 'email', align: 'left' },
  { Header: 'Phone Number', accessor: 'phoneNumber', align: 'right' },
  {
    Header: 'SSN',
    accessor: 'encodedSSN',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'State',
    accessor: 'state',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'City',
    accessor: 'city',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'KYC Approved',
    accessor: 'accountStatus',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Admin Approved',
    accessor: 'isAdminApproved',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Investment Status',
    accessor: 'investmentStatus',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Regulation D Status',
    accessor: 'regulationDStatus',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Properties Invested',
    accessor: 'propertiesInvested',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Total Value',
    accessor: 'propertyValue',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Referral Code',
    accessor: 'referredBy',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Referred By User',
    accessor: 'referredByUser',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Subscribe For SMS',
    accessor: 'subscribeForSMS',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'OnBoarding Stage',
    accessor: 'onboardingStage',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Registered On',
    accessor: 'registeredOn',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
]

// Revenue Report Columns

export const revenueColumns = [
  { Header: 'Transaction ID', accessor: 'id', align: 'left' },
  { Header: 'Property Name', accessor: 'propertyName', align: 'left' },
  { Header: 'Property Type', accessor: 'propertyType', align: 'left' },
  {
    Header: 'Total No. of Transactions',
    accessor: 'totalTransaction',
    align: 'right',
  },
  {
    Header: 'Total Platform Fee',
    accessor: 'platformFees',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Total Transaction Fee',
    accessor: 'transactionFees',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Total Revenue',
    accessor: 'totalRevenue',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
];

// Recurring Revenue Columns

export const recurringRevenueColumns = [
  { Header: 'Date', accessor: 'date', align: 'left' },
  { Header: 'Property Name', accessor: 'propertyName', align: 'left' },
  { Header: 'Property Type', accessor: 'propertyType', align: 'left' },
  {
    Header: 'Revenue from Price of Property(0.125%)',
    accessor: 'revenueFromPriceOfProperty',
    align: 'right',
  },
  {
    Header: 'Revenue from Rent(5 %)',
    accessor: 'revenueFromRents',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Total Recurring Revenue',
    accessor: 'totalRevenue',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
];

// Properties Reports Columns

export const likedColumns = [
  { Header: 'Property Name', accessor: 'propertyName', align: 'left' },
  { Header: 'Property Type', accessor: 'propertyType', align: 'left' },
  { Header: 'Likes', accessor: 'likes', align: 'right' },
];

export const appreciatedColumns = [
  { Header: 'Property Name', accessor: 'propertyName', align: 'left' },
  { Header: 'Property Type', accessor: 'propertyType', align: 'left' },
  { Header: 'LTP', accessor: 'LTP', align: 'right' },
  { Header: 'All Time Gain (%)', accessor: 'gain', align: 'right' },
];

export const tradedColumns = [
  { Header: 'Property Name', accessor: 'propertyName', align: 'left' },
  {
    Header: 'Property Type',
    accessor: 'propertyType',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Total Investors',
    accessor: 'totalInvestors',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Volume',
    accessor: 'volume',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
];

// User Reports Columns

export const usersAcquiredColumns = [
  { Header: 'Legal Name', accessor: 'firstName', align: 'left' },
  {
    Header: 'State',
    accessor: 'state',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  { Header: 'Status (KYC)', accessor: 'isKYCVerified', align: 'left' },
  { Header: 'Status (Admin KYC)', accessor: 'isAdminApproved', align: 'left' },
  {
    Header: 'Investment Status',
    accessor: 'investmentStatus',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
];

export const usersByStateColumns = [
  {
    Header: 'State',
    accessor: 'state',
    align: 'left',
  },
  {
    Header: 'Users',
    accessor: 'users',
    align: 'center',
  },
  {
    Header: 'Total Investments',
    accessor: 'totalInvestments',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
];

export const usersByAgeColumns = [
  {
    Header: 'Age Group',
    accessor: 'ageGroup',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Users',
    accessor: 'investors',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Total Investment',
    accessor: 'totalInvestment',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
];

// Transactions Columns

export const primaryColumns = [
  { Header: 'Transaction ID', accessor: 'id', align: 'left' },
  {
    Header: 'Transaction Date',
    accessor: 'transactionDate',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'NorthCap Trade ID',
    accessor: 'northCapTradeId',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Property Name',
    accessor: 'propertyName',
    align: 'left,',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Property Type',
    accessor: 'propertyType',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'User',
    accessor: 'userName',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Transaction Type',
    accessor: 'transactionType',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Quantity',
    accessor: 'noOfShares',
    align: 'right',
  },
  { Header: 'Price Per Share', accessor: 'pricePerShare', align: 'right' },
  {
    Header: 'Investment Amount',
    accessor: 'totalInvestmentAmount',
    align: 'right',
  },
  {
    Header: 'Platform Fees',
    accessor: 'platformFees',
    align: 'right',
  },
  { Header: 'Equity', accessor: 'equity', align: 'right' },
  {
    Header: 'Funded Status',
    accessor: 'fundedStatus',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
];

export const secondaryColumns = [
  { Header: 'Transaction ID', accessor: 'id', align: 'left' },
  {
    Header: 'Transaction Date',
    accessor: 'transactionDate',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'NorthCap Ask Order ID',
    accessor: 'northCapAskOrderId',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'NorthCap Bid Order ID',
    accessor: 'northCapBidOrderId',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Property Name',
    accessor: 'propertyName',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Property Type',
    accessor: 'propertyType',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Buyer Name',
    accessor: 'buyerName',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Seller Name',
    accessor: 'sellerName',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Last traded price',
    accessor: 'executedSharePrice',
    align: 'left',
  },
  {
    Header: 'Investment Amount',
    accessor: 'totalInvestmentAmount',
    align: 'right',
  },
  { Header: 'Equity', accessor: 'equity', align: 'right' },
];

export const pendingColumns = [
  { Header: 'Order ID', accessor: 'id', align: 'left' },
  {
    Header: 'Transaction Date',
    accessor: 'transactionDate',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'NorthCap Trade ID',
    accessor: 'northCapTradeId',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'NorthCap Order ID',
    accessor: 'northCapOrderId',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Property Name',
    accessor: 'propertyName',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Property Type',
    accessor: 'propertyType',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'User',
    accessor: 'userName',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  { Header: 'Transaction Type', accessor: 'type', align: 'left' },
  { Header: 'Order Duration', accessor: 'duration', align: 'left' }, // duration
  { Header: 'Quantity', accessor: 'noOfShares', align: 'right' },
  { Header: 'Price Per Share', accessor: 'pricePerShare', align: 'right' },
  {
    Header: 'Investment Amount',
    accessor: 'totalInvestmentAmount',
    align: 'right',
  },
  //   { Header: 'Equity', accessor: 'equity', align: 'right' }, NOTE: TBD
];

export const cancelledColumns = [
  { Header: 'Order ID', accessor: 'id', align: 'left' },
  {
    Header: 'Transaction Date',
    accessor: 'transactionDate',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'NorthCap Trade ID',
    accessor: 'northCapTradeId',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'NorthCap Order ID',
    accessor: 'northCapOrderId',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Property Name',
    accessor: 'propertyName',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Property Type',
    accessor: 'propertyType',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'User',
    accessor: 'userName',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  { Header: 'Transaction Type', accessor: 'type', align: 'left' },
  {
    Header: 'Cancelled By',
    accessor: 'cancelledBy',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  { Header: 'Quantity', accessor: 'noOfShares', align: 'right' },
  { Header: 'Price Per Share', accessor: 'pricePerShare', align: 'right' },
  {
    Header: 'Investment Amount',
    accessor: 'totalInvestmentAmount',
    align: 'right',
  },
];

export const withdrawalColumns = [
  {
    Header: 'Transfer Id', accessor: 'transferId', align: 'left', disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Email',
    accessor: 'userEmail',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Source',
    accessor: 'source',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Destination',
    accessor: 'destination',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Transfer Date',
    accessor: 'transferDate',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Action', accessor: 'type', align: 'left', disableFilters: true,
    disableSortBy: true,
  },
];

export const accountStatementColumns = [
  {
    Header: 'Date',
    accessor: 'date',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Statement',
    accessor: 'statement',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: '',
    accessor: 'download',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
];

export const sellYourPropertiesColumns = [
  { Header: 'Sell ID', accessor: 'id', align: 'left' },
  { Header: 'Name', accessor: 'firstName', align: 'left' },
  { Header: 'Email', accessor: 'email', align: 'left' },
  {
    Header: 'Phone Number',
    accessor: 'phoneNumber',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Property Address',
    accessor: 'propertyAddress',
    align: 'left',
  },
  {
    Header: 'Property Type',
    accessor: 'propertyType',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Asking Price',
    accessor: 'askingPrice',
    align: 'left',
  },
  {
    Header: 'Duration',
    accessor: 'duration',
    align: 'left',
  },
  {
    Header: 'Is Occupied?',
    accessor: 'isOccupied',
    align: 'left',
    // disableFilters: true,
    // disableSortBy: true,
  },
];

export const investedPropertiesColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  { Header: 'Property Name', accessor: 'name', align: 'left' },
  {
    Header: 'Shares Purchased',
    accessor: 'shares',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Amount Invested',
    accessor: 'amountInvested',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },

  {
    Header: 'Dividend Received',
    accessor: 'totalDividendReceived',
    align: 'right',
    disableFilters: true,
    disableSortBy: true,
  },
];

export const savedPropertiesColumns = [
  {
    Header: 'ID',
    accessor: 'id',
    align: 'left',
  },
  { Header: 'Property Name', accessor: 'propertyName', align: 'left' },
  {
    Header: 'Property Type',
    accessor: 'propertyType',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
];

export const fundingSourceColumns = [
  {
    Header: 'User Id', accessor: 'id', align: 'left', disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Email',
    accessor: 'userEmail',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Source Type',
    accessor: 'sourceType',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Funding Source',
    accessor: 'fundingSource',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Is Primary',
    accessor: 'isPrimary',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Date',
    accessor: 'date',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Action', accessor: 'type', align: 'center', disableFilters: true,
    disableSortBy: true,
  },
];


export const DeactivatedUsersColumns = [
  {
    Header: 'User Id', accessor: 'userId', align: 'left', disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Name',
    accessor: 'name',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Email',
    accessor: 'email',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'State',
    accessor: 'state',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'City',
    accessor: 'city',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'KYC Approved',
    accessor: 'isKYCVerified',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Admin Approved',
    accessor: 'isAdminApproved',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Phone Number',
    accessor: 'phoneNumber',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Subscribe For SMS',
    accessor: 'subscribeForSMS',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Referred By',
    accessor: 'referredBy',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Onboarding Stage',
    accessor: 'onboardingStage',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Registered On',
    accessor: 'registeredOn',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Regulation D Status',
    accessor: 'isRegDInvestor',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
  {
    Header: 'Referred By User',
    accessor: 'referredUser',
    align: 'left',
    disableFilters: true,
    disableSortBy: true,
  },
];

